import React, { useEffect, useState } from "react";
import styles from "./DateTimeInputSection.module.css";
import { DatePicker } from "@material-ui/pickers";
import moment from "moment";
import { useTranslation } from "react-i18next";

const DateTimeInputSection = ({ openings, onChangeDateTime, events }) => {
  const { t } = useTranslation();

  const [selectedDate, setSelectedDate] = useState(null);
  const [previousDate, setPreviousDate] = useState(null);

  useEffect(() => {
    if (selectedDate && selectedDate !== previousDate) {
      const startingTime = new Date(openings.ora_inizio);
      const dateTime = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        startingTime.getHours(),
        startingTime.getMinutes()
      );
      onChangeDateTime(dateTime);
      setPreviousDate(selectedDate);
    }
  }, [selectedDate, previousDate, openings, onChangeDateTime]);

  return (
    !moment(openings.ora_inizio).isSame(openings.ora_fine, "day") && (
      <div className={styles.dataTimeContainer}>
        <div style={{ width: "100%" }}>
          <DatePicker
            label={t("selectData")}
            value={selectedDate}
            onChange={setSelectedDate}
            shouldDisableDate={day =>
              !events.some(ev => moment(ev.ora_inizio).isSame(day, "day"))
            }
            animateYearScrolling
            format="dd/MM/yyyy"
            minDate={moment()}
          />
        </div>

        {/*<div style={{ width: "50%"}}>
        <TimePicker
          ampm={false}
          label={t("selectTime")}
          value={selectedTime}
          onChange={setSelectedTime}
          minutesStep={15}
        />
      </div>*/}
      </div>
    )
  );
};

export default DateTimeInputSection;
